import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useState } from 'react';
import { Flex } from '@chakra-ui/react';
import { Input } from '../../../../inputs';
import { VirtualTable } from '../../../../tables';
const SamplesDialogFC = ({ samples, selectedSamplesIdx, onAddSample, onDeleteSample }) => {
    const [query, setQuery] = useState('');
    const filteredProbes = samples.filter((item) => item.sampleName.toLowerCase().includes(query.toLowerCase()));
    const columns = [{ name: 'Название' }];
    const rows = filteredProbes.map(({ sampleId, sampleName }) => ({
        key: sampleId,
        isDisabled: false,
        values: [sampleName],
        isSelected: selectedSamplesIdx.includes(sampleId)
    }));
    return (_jsxs(Flex, { flexDirection: "column", w: "220px", gap: "12px", children: [_jsx(Input, { size: "xs", variant: "outline", value: query, placeholder: "\u041F\u043E\u0438\u0441\u043A", onChange: setQuery }), _jsx(VirtualTable, { isCheckboxShown: true, columns: columns, rows: rows, tableSx: { height: 300 }, noItemsTitle: 'Нет проб', onSelect: onAddSample, onUnselect: onDeleteSample })] }));
};
export const SamplesDialog = memo(SamplesDialogFC);
//# sourceMappingURL=SamplesDialog.js.map